import { trackGenericClickInteractions } from "./events/genericClickInteractions";
import { trackGenericImpressions } from "./events/genericImpressions";

const initializeAnalyticsInteractions = () => {
    trackGenericImpressions();
    trackGenericClickInteractions();
};

export * from "./events/genericClickInteractions";
export * from "./events/genericImpressions";
export * from "./trackers";
export * from "./types/eventTypes";
export * from "./types/analyticsEvent";
export * from "./types/trackingInfo";
export * from "./tracking.service";

export { initializeAnalyticsInteractions };
